module.exports = __webpack_public_path__ + "static/media/img-location-yunlin-en.1a38b9b9.svg";